var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.402,
    height: 55.982,
    viewBox: "0 0 71.402 55.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M69.171,110.652H8.925V66.333A2.283,2.283,0,0,0,6.694,64H2.231A2.283,2.283,0,0,0,0,66.333v48.984a4.568,4.568,0,0,0,4.463,4.665H69.171A2.283,2.283,0,0,0,71.4,117.65v-4.665A2.283,2.283,0,0,0,69.171,110.652ZM64.708,68.665H48.244a3.521,3.521,0,0,0-2.367,5.973L50.4,79.362l-10.232,10.7-10.232-10.7a4.325,4.325,0,0,0-6.31,0L14.042,89.377a2.408,2.408,0,0,0,0,3.3l3.155,3.3a2.163,2.163,0,0,0,3.156,0l6.423-6.716,10.232,10.7a4.325,4.325,0,0,0,6.31,0l13.388-14,4.518,4.723a3.331,3.331,0,0,0,5.714-2.474V71A2.281,2.281,0,0,0,64.708,68.665Z",
    transform: "translate(0 -64)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChart);
export default __webpack_public_path__ + "static/media/icon-chart.68a62de745faa6480e8d25b1a2f77edb.svg";
export { ForwardRef as ReactComponent };